import { render, staticRenderFns } from "./jchg.vue?vue&type=template&id=7d982eaa&scoped=true&"
import script from "./jchg.vue?vue&type=script&lang=js&"
export * from "./jchg.vue?vue&type=script&lang=js&"
import style0 from "./jchg.vue?vue&type=style&index=0&id=7d982eaa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d982eaa",
  null
  
)

export default component.exports